import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

const services = [
  ["Search Engine Optimization", "/services/seo"],
  ["Google Ads & PPC", "/services/ppc"],
  ["Social Media Marketing", "/services/social-media"],
  ["Content & Creative", "/services/content"],
  ["Web Design & Development", "/services/web-development"],
  ["Branding & Creative Design", "/services/branding"],
  ["Email & WhatsApp Marketing", "/services/email-whatsapp"],
  ["AI & Marketing Automation", "/services/ai-automation"],
];

const company = [
  ["About Us", "/about"],
  ["Our Process", "/process"],
  ["Our Work", "/work"],
  ["Pricing", "/pricing"],
  ["Resources", "/resources"],
  ["Contact", "/contact"],
];

const socials = [
  {
    href: "https://www.linkedin.com/company/digitalmonks4you/",
    title: "LinkedIn",
    svg: <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
  },
  {
    href: "https://www.instagram.com/digitalmonks4you",
    title: "Instagram",
    svg: <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.406-11.845a1.44 1.44 0 1 0 0 2.881 1.44 1.44 0 0 0 0-2.881z"/></svg>
  },
  {
    href: "https://www.facebook.com/digitalmonks4you",
    title: "Facebook",
    svg: <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
  },
];

export default function Footer() {
  return (
    <footer className="site-footer">
      {/* Top CTA band */}
      <div className="footer-cta-band">
        <div className="container footer-cta-inner">
          <div>
            <div className="footer-cta-kicker">Ready to grow?</div>
            <h2 className="footer-cta-heading">Let's build something <span className="gradient">remarkable.</span></h2>
            <p className="footer-cta-sub">Free consultation. No commitment. Just clarity on your next move.</p>
          </div>
          <div className="footer-cta-actions">
            <Link to="/contact" className="cta">Book Free Strategy Call →</Link>
            <Link to="/work" className="footer-cta-secondary">View Our Work ↗</Link>
          </div>
        </div>
      </div>

      {/* Main footer body */}
      <div className="footer-body">
        <div className="container">
          <div className="footer-grid">

            {/* Brand col */}
            <div className="footer-brand">
              <img src={logo} alt="Digital Monks 4 You" className="footer-logo" />
              <p className="footer-brand-desc">
                Full-service digital marketing agency combining strategy, creativity and technology to deliver measurable, lasting growth.
              </p>
              <div className="footer-stats">
                <div className="footer-stat"><strong>500+</strong><span>Projects</span></div>
                <div className="footer-stat"><strong>300+</strong><span>Clients</span></div>
                <div className="footer-stat"><strong>4</strong><span>Markets</span></div>
              </div>
              <div className="footer-socials">
                {socials.map(s => (
                  <a key={s.title} href={s.href} title={s.title} target="_blank" rel="noopener noreferrer" className="footer-social-btn">{s.svg}</a>
                ))}
              </div>
            </div>

            {/* Services col */}
            <div className="footer-col">
              <div className="footer-col-heading">Services</div>
              {services.map(([label, to]) => (
                <Link key={to} to={to} className="footer-link">{label}</Link>
              ))}
            </div>

            {/* Company col */}
            <div className="footer-col">
              <div className="footer-col-heading">Company</div>
              {company.map(([label, to]) => (
                <Link key={to} to={to} className="footer-link">{label}</Link>
              ))}
            </div>

            {/* Contact col */}
            <div className="footer-col">
              <div className="footer-col-heading">Get In Touch</div>
              <div className="footer-contact-block">
                <div className="footer-contact-item">
                  <span className="footer-contact-icon">📞</span>
                  <div>
                    <div className="footer-contact-label">Phone / WhatsApp</div>
                    <a href="tel:+917991721062" className="footer-contact-val">+91 79917 21062</a>
                    <a href="tel:+919035901062" className="footer-contact-val">+91 90359 01062</a>
                  </div>
                </div>
                <div className="footer-contact-item">
                  <span className="footer-contact-icon">✉</span>
                  <div>
                    <div className="footer-contact-label">Email</div>
                    <a href="mailto:info@digitalmonks4you.com" className="footer-contact-val">info@digitalmonks4you.com</a>
                  </div>
                </div>
                <div className="footer-contact-item">
                  <span className="footer-contact-icon">🌍</span>
                  <div>
                    <div className="footer-contact-label">We serve</div>
                    <div className="footer-contact-val">Varanasi, India · UAE · UK · US</div>
                  </div>
                </div>
              </div>

              <div className="footer-badges">
                <div className="footer-badge">🏅 Google Partner</div>
                <div className="footer-badge">📊 Meta Certified</div>
              </div>
            </div>

          </div>

          {/* Bottom bar */}
          <div className="footer-bottom">
            <div className="footer-bottom-left">
              <span>© 2026 Digital Monks 4 You. All Rights Reserved.</span>
              <span className="footer-tagline">Think Digital. Grow Beyond.</span>
            </div>
            <div className="footer-bottom-right">
              <Link to="/privacy">Privacy Policy</Link>
              <span>·</span>
              <Link to="/terms">Terms of Service</Link>
              <span>·</span>
              <Link to="/contact">Contact</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}